import { AddAssetDropdown, Button, DashboardTopBar } from "shared";
import { AssetCategorySlug } from "enums/AssetCategoryEnum";
import { SVG_ENUM } from "enums";
import { isDesktop } from "utils";
import { openMeetingBooking } from "../utils";
import { CompaniesTabsType } from "../types";

interface InvestmentsTopBarProps {
  tab: CompaniesTabsType["tab"];
  isAdmin: boolean;
  isCompanyInfoOpenModal: boolean;
  onAssetSelect: (slug: string) => void;
}

const InvestmentsTopBar = ({
  tab,
  isAdmin,
  isCompanyInfoOpenModal,
  onAssetSelect,
}: InvestmentsTopBarProps) => {
  return (
    <DashboardTopBar>
      <h1 className="dashboard__header">Moje aktywa</h1>
      <div className="companies__buttons">
        {tab === "my" ? (
          <Button
            onClick={openMeetingBooking}
            className="dashboard__top-button button--rounded button--hide-on-mobile button--transparent companies__meeting"
            label="Umów spotkanie"
            svg={SVG_ENUM.CALENDAR}
          />
        ) : null}

        {isDesktop() &&
          (tab === "my" || (isAdmin && tab === "reliance")) &&
          !isCompanyInfoOpenModal && (
            <AddAssetDropdown
              onSelect={(slug: AssetCategorySlug) => {
                onAssetSelect(slug);
              }}
            />
          )}
      </div>
    </DashboardTopBar>
  );
};

export default InvestmentsTopBar;
